export { default as DownloadableResultsGuidePage } from "./downloadableResultsGuide";
